import createRequestTypes from '../../services/requestsTypes';

const filePrefix = 'DPD';
export const HAS_SUBSCRIPTION = createRequestTypes(`${filePrefix}_HAS_SUBSCRIPTION`);
export const POST_CHECKOUT = createRequestTypes(`${filePrefix}_POST_CHECKOUT`);

export const hasSubscriptionRequest = () => ({
  type: HAS_SUBSCRIPTION.REQUEST,
});
export const hasSubscriptionSuccess = (data: any) => ({
  type: HAS_SUBSCRIPTION.SUCCESS,
  data,
});
export const hasSubscriptionFailure = (error: any) => ({
  type: HAS_SUBSCRIPTION.FAILURE,
  error,
});

export const postCheckoutRequest = () => ({
  type: POST_CHECKOUT.REQUEST,
});
export const postCheckoutSuccess = (data: any) => ({
  type: POST_CHECKOUT.SUCCESS,
  data,
});
export const postCheckoutFailure = (error: any) => ({
  type: POST_CHECKOUT.FAILURE,
  error,
});
